import React, { useCallback, useEffect, useState, } from "react";
import { fetchStore } from "@ludens-reklame/rubics-v3-sdk/store";
// {} as IStoreContext is a hack, as it actually is not necessary to provide default values here
export const StoreContext = React.createContext({});
export const StoreContextProvider = ({ store, children }) => {
    const [_store, setStore] = useState(store);
    const _fetchStore = useCallback(async (admin, variants) => {
        const newStore = await fetchStore({
            endpoint: store.context.url.pathname.replace("/api/v1/admin", ""),
            csrfToken: _store.context.csrfToken || "",
            admin,
            variants,
        });
        setStore(newStore);
    }, [store.context.url.pathname]);
    useEffect(() => {
        if (store.context.adminMode) {
            function listener(e) {
                const payload = e.data;
                if (payload.type === "refresh") {
                    _fetchStore(true, payload.data?.variants);
                }
            }
            window.addEventListener("message", listener, { passive: true });
            return () => {
                window.removeEventListener("message", listener);
            };
        }
    }, []);
    return (React.createElement(StoreContext.Provider, { value: {
            store: _store,
            setStore,
        } }, children));
};
